import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import styles from './styles.module.scss'
import MixrItem from './MixrItem'
import EmptyCard from '../../common/EmptyCard'

function MostSuccessfulMixrs({ data, selectedDuration }) {
  const { t } = useTranslation()
  const [selectedCategory, setSelectedCategory] = useState({
    label: t('dashboard.mostSuccessfulMixrs.participationRatio'),
    value: 'participation_ratio'
  })

  const [options, setOptions] = useState([
    {
      label: t('dashboard.mostSuccessfulMixrs.participationRatio'),
      value: 'participation_ratio'
    },
    {
      label: t('global.engagement', { count: 0 }),
      value: 'engagement'
    }
  ])

  const [mixrData, setMixrData] = useState(null)

  useEffect(() => {
    if (data && data[selectedDuration]) {
      setMixrData(data[selectedDuration])
    }
  }, [data, selectedDuration])

  const sortingGroup = (a, b) => {
    switch (selectedCategory.value) {
      case 'engagement':
        return parseFloat(b.engagementValue) - parseFloat(a.engagementValue)
      case 'participation_ratio':
        return b.mixrsValue - a.mixrsValue
      default:
        return b.ratingValue - a.ratingValue
    }
  }

  const objectToList = (object) => object && Object.values(object).sort((a, b) => sortingGroup(a, b))

  const items = mixrData?.[`most_succesful_by_${selectedCategory.value}`]
    ? objectToList(mixrData?.[`most_succesful_by_${selectedCategory.value}`])?.map((e, i) => {
        return (
          <MixrItem
            key={i}
            rank={i + 1}
            mixrId={e.mixr_info?.id}
            eventName={e.mixr_info?.name}
            value={e.value}
            numberOfParticipants={e.number_of_participants}
            selectedCategory={selectedCategory}
            eventPicture={e.mixr_info?.picture.url}
          />
        )
      })
    : []

  return (
    <div className={`${styles.successfulMixrContainer}`}>
      <div className={styles.header}>
        <h3 className={styles.title}>{t('dashboard.mostSuccessfulMixrs.title')}</h3>
        <Dropdown1
          options={options}
          value={selectedCategory}
          className={styles.dropdown}
          onChange={(e) => {
            setSelectedCategory(e)
          }}
        />
      </div>

      {items.length === 0 ? (
        <EmptyCard
          contentTitle={t('dashboard.mostSuccessfulMixrs.noMixrTitle')}
          contentText={t('dashboard.mostSuccessfulMixrs.noMixrDescription')}
          contentImage='void'
        />
      ) : (
        <div className={styles.list}>{items}</div>
      )}
    </div>
  )
}

export default MostSuccessfulMixrs
